// import deps
import * as Item from '../../../items';
import * as Constant from '../../../constants';
import { COLORS as HIDDEN_LEAF_COLORS } from '../../../Modes/HiddenLeaf/theme';
import { Player } from '../../../Entities/index';
import { ContainerSlot } from '../../../Entities/Containing';
import {ChakraResource} from '../../../Actions/ActionResources/ChakraResource';
import {PrepareDirectionalThrow} from '../../../Actions/PrepareDirectionalThrow';
import SpatterEmitter from '../../../Engine/Particle/Emitters/spatterEmitter';
import * as Helper from '../../../../helper';
import { PiercingKunai } from '../../../Modes/HiddenLeaf/Items/Weapons/PiercingKunai';
import { ExplodingTag } from '../../../Modes/HiddenLeaf/Items/Weapons/ExplodingTag';
import { PrepareSubstitution } from '../../../Actions/PrepareSubstitution';
import * as TentenSummons from '../../../Modes/HiddenLeaf/Items/Weapons/TentenSummons';
import { SpawnAndPlaceItem } from '../../../Actions/SpawnAndPlaceItem';
import { generateDefaultKeymapActions, generatePlayerCharacterOptions } from '../../../Modes/HiddenLeaf/Characters/Utilities/characterHelper';
import { SOUNDS } from '../sounds';

const portrait =  `${window.PUBLIC_URL}/hidden_leaf/tenten.png`;

const speedRating = 1
const durabilityRating = 2
const chakraRating = 2

const basicInfo = {
  name: 'Tenten',
  description: 'The weapons specialist',
  renderer: {
    character: 'T',
    color: HIDDEN_LEAF_COLORS.tenten_alt,
    background: HIDDEN_LEAF_COLORS.tenten,
    portrait,
    basePortrait: portrait,
    damageFlashPortrait: `${window.PUBLIC_URL}/hidden_leaf/white.png`,
  },
  abilities: [
    {
      name: 'Kunai Throw',
      description: 'Throws a kunai in the direction of the target.',
    },
    {
      name: 'Exploding Tags',
      description: 'Throws an exploding tag in the direction of the target.',
    },
    {
      name: 'Summon Weapon',
      description: 'Summons a random, powerful weapon.',
    },
  ],
  speedRating,
  durabilityRating,
  chakraRating,
  speed: speedRating * 200,
  durability: durabilityRating * 3,
  charge: chakraRating * 3,
  chargeMax: chakraRating * 3,
  attackDamage: 1,
  portrait,
}

function initialize (engine) {

  async function summonSuccess(position) {
    const spatterEmitter = SpatterEmitter({
      game: engine.game,
      fromPosition: position,
      spatterRadius: 5,
      spatterAmount: 0.3,
      spatterDirection: { x: 0, y: 0 },
      spatterColors: [HIDDEN_LEAF_COLORS.red, HIDDEN_LEAF_COLORS.wraps],
      animationTimeStep: 0.9,
      reverse: true,
      transfersBackground: false,
      transfersBackgroundOnDestroy: false,
    })
    await spatterEmitter.start()
  }

  // define keymap
  const keymap = (engine, actor) => {
    return {
      ...generateDefaultKeymapActions(engine, actor),
      t: () => new PrepareDirectionalThrow({
        label: 'Throw Kunai',
        game: engine.game,
        actor,
        passThroughEnergyCost: Constant.ENERGY_THRESHOLD,
      }),
      l: () => {
        // const item = Item.sword(engine);
        // let item = TentenSummons.getRandomWeapon(engine, actor.getPosition())
        
        // return new EquipItem({
        //   label: 'Weapon Scroll Summon',
        //   item,
        //   game: engine.game,
        //   actor,
        //   energyCost: Constant.ENERGY_THRESHOLD,
        //   requiredResources: [new ChakraResource({ getResourceCost: () => 1 })],
        //   onBefore: () => item = TentenSummons.getRandomWeapon(engine, actor.getPosition()),
        //   onSuccess: () => summonSuccess(actor.getPosition()),
        //   onFailure: () => destroyEntity(item),
        // });
        
        // get open neighboring position
        const neigbors = Helper.getNeighboringPoints(actor.getPosition(), false)
        const neigbor = Helper.getRandomInArray(neigbors)
        return new SpawnAndPlaceItem({
          label: 'Weapon Scroll Summon',
          entitySpawnFunction: TentenSummons.getRandomWeapon,
          targetPos: neigbor,
          game: engine.game,
          actor,
          energyCost: Constant.ENERGY_THRESHOLD,
          requiredResources: [new ChakraResource({ getResourceCost: () => 1 })],
          onSuccess: () => {
            SOUNDS.summon_1.play()
            summonSuccess(neigbor)
          },
        });
      },
      f: () => new PrepareDirectionalThrow({
        label: 'Exploding Tag',
        projectileType: 'exploding tag',
        game: engine.game,
        actor,
        passThroughEnergyCost: Constant.ENERGY_THRESHOLD,
      }),
      r: () => new PrepareSubstitution({
        label: 'Substitution',
        game: engine.game,
        actor,
        passThroughEnergyCost: Constant.ENERGY_THRESHOLD,
        passThroughRequiredResources: [new ChakraResource({ getResourceCost: () => 1 })]
      }),
    };
  }
  // instantiate class
  let actor = new Player({
    ...generatePlayerCharacterOptions(basicInfo, engine, keymap),
  })

  // add default items to container
  const kunais = Array(3).fill('').map(() => Item.directionalKunai(engine, { ...actor.pos }, null, 10));
  // const swords = Array(2).fill('').map(() => Item.sword(engine));
  const tags = Array(2).fill('').map(() => ExplodingTag(engine, { ...actor.pos }));
  actor.container = [
    new ContainerSlot({
      itemType: kunais[0].name,
      items: kunais,
    }),
    new ContainerSlot({
      itemType: tags[0].name,
      items: tags,
    }),
  ]

  const jutsu = PiercingKunai(engine, actor.getPosition());
  actor.addEquipmentSlot({type: jutsu.equipmentType})
  actor.equip(jutsu.equipmentType, jutsu);
  return actor;
}

export default function () {
  return {
    basicInfo,
    initialize,
  }
}